import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { MarkdownContent } from '@/components/MarkdownContent/MarkdownContent';
import { COMMON_NAMESPACE } from '@/i18n';

type TermsDocumentPanelProps = {
  content: string;
};

export function TermsDocumentPanel({
  content,
}: TermsDocumentPanelProps): JSX.Element {
  const { t } = useTranslation(COMMON_NAMESPACE);

  return (
    <Box
      component="section"
      className="terms-document-panel"
      data-testid="terms-document-panel"
      aria-label={t('termsDocumentAriaLabel')}
    >
      <MarkdownContent content={content} />
    </Box>
  );
}
